import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchOrders, FetchOrdersResponse, Order, Cart } from './orderManageApi';

interface OrderManageState {
  orders: Order[];
  carts: Cart[];
  status: 'idle' | 'loading' | 'succeeded' | 'failed';
  error: string | null;
}

const initialState: OrderManageState = {
  orders: [],
  carts: [],
  status: 'idle',
  error: null,
};

export const fetchOrdersAsync = createAsyncThunk(
  'orderManage/fetchOrders',
  async (activeStoreId: string) => {
    const response = await fetchOrders(activeStoreId);
    return response;
  }
);

const orderManageSlice = createSlice({
  name: 'orderManage',
  initialState,
  reducers: {
    // 強制的に状態をリセットするアクション
    resetOrderState: (state) => {
      state.status = 'idle';
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrdersAsync.pending, (state) => {
        state.status = 'loading';
        console.log('Fetching orders: PENDING');
      })
      .addCase(fetchOrdersAsync.fulfilled, (state, action) => {
        console.log('Fetching orders: FULFILLED with data:', action.payload);
        // 新しい配列参照を作成して確実に状態を更新
        state.orders = [...action.payload.orders];
        state.carts = [...action.payload.carts];
        state.status = 'succeeded';
      })
      .addCase(fetchOrdersAsync.rejected, (state, action) => {
        console.log('Fetching orders: REJECTED with error:', action.error);
        state.status = 'failed';
        state.error = action.error.message || 'Failed to fetch orders';
      });
  },
});

// アクションをエクスポート
export const { resetOrderState } = orderManageSlice.actions;

export default orderManageSlice.reducer;
